import { BotConfig } from "@/API";
import { Button, Group, Modal, NumberInput, Stack, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function BotConfigEditButton(props: { value?: BotConfig, onChange?: (value: BotConfig) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);

    const form = useForm<BotConfig>({
        initialValues: props.value,

    });
    useEffect(() => {
        if (opened) {
            if (props.value) form.setValues(props.value)
            else form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="回應設定">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values)
                close()
            })}>
                <Stack gap={5} mt={5}>
                    <Textarea
                        label="思考中回應"
                        rows={3}
                        {...form.getInputProps('waitingResponseMessage')}
                    />
                    <NumberInput
                        label="多少秒還沒回答自動回應思考中回應(0表示關閉此功能)"
                        min={0}
                        step={1}
                        {...form.getInputProps('waitingResponseTime')}
                    />
                    <Textarea
                        label="發生錯誤時的回應"
                        rows={3}
                        {...form.getInputProps('errorMessage')}
                    />
                </Stack>
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}